/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

import {TextFieldWrap} from 'components/InputsNew/TextFieldWrap';

import {MAX_CONTENT_WIDTH} from './constants';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  padding: theme.spacing(4, 4, 0, 4),
  overflowY: 'auto',
  maxHeight: 'calc(100vh - 128px)',
}));

export const QuestionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export const QuestionGroup = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  width: '100%',
}));

export const LabelBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'center',

  [`${theme.breakpoints.down('sm')}`]: {
    flexDirection: 'column-reverse',
  },
}));

export const TextareaQuestionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const RegularTextBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: `${MAX_CONTENT_WIDTH}px`,
}));

export const LabelText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const RequiredBadge = styled(Box)(({theme}) => ({
  height: '18px',
  borderRadius: '9px',
  background: theme.palette.semantic_light?.primary.container,
  padding: theme.spacing(0, 1),
  display: 'flex',
  alignItems: 'center',
  userSelect: 'none',

  color: theme.palette.semantic_light?.primary.onContainer,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '14px',
}));

export const SubmitButtons = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  background: theme.palette.figma_gray_light_4?.main,
  position: 'sticky',
  width: '100%',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  bottom: 0,
  zIndex: 10,

  [`${theme.breakpoints.down('sm')}`]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const TextareaBox = styled(Box)(() => ({
  position: 'relative',
}));

export const TextareaIconBox = styled(Box)(({theme}) => ({
  position: 'absolute',
  left: '8px',
  top: '6px',
  pointerEvents: 'none',
  userSelect: 'none',
  opacity: '0.5',

  '.MuiSvgIcon-root': {
    color: theme.palette.semantic_light?.surface.onSurface,
    fontSize: '20px',
  },
}));

interface StyledTextFieldWrapProps {
  paddingBottom?: number;
}

export const StyledTextFieldWrap = styled(TextFieldWrap, {
  shouldForwardProp: prop => prop !== 'paddingBottom',
})<StyledTextFieldWrapProps>(({theme, paddingBottom}) => ({
  minHeight: 'unset',

  '.MuiInputBase-root': {
    color: theme.palette.semantic_light?.surface.onSurface,
    padding: theme.spacing(2, 2, paddingBottom ?? 12, 9),
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.semantic_light?.surface.onSurfaceMuted,
  },
  '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.semantic_light?.primary.hover,
  },
}));
